export const migrateToV2 = (state)=>{
    return state;
};

//# sourceMappingURL=v2.js.map